<template>
    <div>
        <BaseLoader/>
    </div>
</template>


<script>
export default {
}
</script>



// WEBPACK FOOTER //
// src/components/checkout/payment/PaymentResponse.vue